/* eslint-disable react/style-prop-object */
import React from "react";
import { useSelector } from "react-redux";

import { useFormik } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../../Helpers/Input/Input";
import Button from "../../../../../../Helpers/Button/Button";
import {
	useGetSpecificDeviceQuery,
	useUpdateDeviceByIdMutation,
} from "../../../../../../../Redux/Devicestwo";
import { toast } from "react-toastify";
import trans from "../../../../../../../utils";
import Loader from "../../../../../../Helpers/Loader/Loader";
import {
	SpeedInputValue,
	SpeedValue,
} from "../../../../../../../JsHelpers/PlatformUnits";

const SetSpeedLimit = ({ device, setControlsPopup, setIsControlsPopup }) => {
	const {
		data: oldData,
		refetch,
		isLoading,
	} = useGetSpecificDeviceQuery(device?.id, { skip: !device?.id });
	const [updateDeviceById] = useUpdateDeviceByIdMutation();
	const inf = useSelector((state) => state.users.user);

	const formik = useFormik({
		initialValues: {
			speedLimit:
				SpeedInputValue(
					oldData?.length > 0 && oldData?.[0].attributes?.speedLimit,
					inf.attributes.speedUnit || "kn"
				) || "",
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			speedLimit: Yup.number()
				.required(trans("Speed limit is required"))
				.min(1, trans("Speed limit must be more than 0")),
		}),
		onSubmit: async (val) => {
			try {
				const body = {
					id: device?.id,
					attributes: {
						fuelIncreaseThreshold:
							oldData?.[0].attributes?.fuelIncreaseThreshold,
						fuelDropThreshold: oldData?.[0].attributes?.fuelDropThreshold,
						speedLimit: SpeedValue(
							val.speedLimit,
							inf.attributes?.speedUnit || "kn"
						),
					},
					groupId: oldData?.[0].groupId,
					calendarId: oldData?.[0].calendarId,
					name: oldData?.[0].name,
					uniqueId: oldData?.[0].uniqueId,
					status: oldData?.[0].status,
					lastUpdate: oldData?.[0].lastUpdate,
					positionId: oldData?.[0].positionId,
					phone: oldData?.[0].phone,
					model: oldData?.[0].model,
					contact: oldData?.[0].contact,
					category: oldData?.[0].category,
					disabled: oldData?.[0].disabled,
					expirationTime: oldData?.[0].expirationTime,
				};
				await updateDeviceById({ id: device?.id, val: body }).unwrap();
				await refetch();
				setControlsPopup("");
				setIsControlsPopup(false);
				toast.success(trans("Speed Limit has been set successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} catch (error) {
				toast.error(
					trans("Error while setting Speed Limit, please try again later"),
					{
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					}
				);
			}
		},
	});

	if (isLoading) return <Loader />;

	return (
		<form onSubmit={formik.handleSubmit}>
			<div>
				<Input
					title={trans("Enter Speed Limit")}
					type="number"
					placeholder={`120 ${trans(inf.attributes?.speedUnit || "kn")}`}
					id="speedLimit"
					name="speedLimit"
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					value={formik.values.speedLimit}
				/>
				{formik.touched.speedLimit && formik.errors.speedLimit ? (
					<div className="validation">{formik.errors.speedLimit}</div>
				) : null}
				<div className="w-100 flex-row justify-end mt-12">
					<Button text={trans("Save")} htmlType="submit" type="primary" />
				</div>
			</div>
		</form>
	);
};

export default SetSpeedLimit;
